import './AutoLockMessage.scss';

import { useState, useEffect } from 'react';

import { useAutoLock } from '../../../../contexts/AutoLockContext';

const HINT_TIME = 3 * 60;

function AutoLockMessage() {
  const { remaining, maxTime } = useAutoLock();

  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    console.log(`remaining >>>> ${remaining}`);

    if (remaining === maxTime || remaining <= 0) {
      setVisible(false);
    }

    // if remaining time equal 3 minutes
    if (remaining >= 0 && remaining <= HINT_TIME) {
      setVisible(true);
    }
  }, [remaining, maxTime]);

  if (!visible) {
    return null;
  }

  return (
    <div className="auto-lock-message-popup-background">
      <div className="auto-lock-message">
        <div className="auto-lock-message-popup">
          <div className="auto-lock-message-emoji">🔐</div>
          <div className="auto-lock-message-texts">
            <div className="auto-lock-message-title">Ooops! Auto lock notification!</div>
            <div className="auto-lock-message-text">
              Dear user, you have not used the program for a long time and for that you will be automatically
              logged out.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AutoLockMessage;
